import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "apt-stats" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "통계 분석"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "실거래 데이터를 조건별로 집계하고 두 조건을 나란히 비교합니다")
], -1)
const _hoisted_3 = { class: "metric-bar" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mb-label" }, "표시 항목", -1)
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "plus" }, "+", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "비교 조건 추가", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ac-hint" }, "다른 지역·평형과 나란히 비교", -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatsPanel = _resolveComponent("StatsPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metricDefs, (m) => {
        return (_openBlock(), _createElementBlock("label", {
          key: m.key,
          class: _normalizeClass(["mb-chip", { on: _ctx.metrics[m.key] }])
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": ($event: any) => ((_ctx.metrics[m.key]) = $event)
          }, null, 8, _hoisted_5), [
            [_vModelCheckbox, _ctx.metrics[m.key]]
          ]),
          _createTextVNode(" " + _toDisplayString(m.label), 1)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["panels", { single: !_ctx.compare }])
    }, [
      _createVNode(_component_StatsPanel, {
        "gu-options": _ctx.guOptions,
        metrics: _ctx.metrics,
        accent: "#4a9fe0",
        initial: { sggCd: '11680', minPy: 24, maxPy: 27 },
        onStats: _cache[0] || (_cache[0] = ($event: any) => (_ctx.panelAStats = $event))
      }, null, 8, ["gu-options", "metrics"]),
      (_ctx.compare)
        ? (_openBlock(), _createBlock(_component_StatsPanel, {
            key: 0,
            "gu-options": _ctx.guOptions,
            metrics: _ctx.metrics,
            accent: "#e0a53a",
            removable: true,
            initial: { sggCd: '11230', minPy: 24, maxPy: 27 },
            "compare-base": _ctx.panelAStats,
            onRemove: _cache[1] || (_cache[1] = ($event: any) => (_ctx.compare = false))
          }, null, 8, ["gu-options", "metrics", "compare-base"]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "add-compare",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.compare = true))
          }, _hoisted_9))
    ], 2)
  ]))
}